module.exports = __webpack_public_path__ + "img/24_15.febc005c.png";